import React, { useEffect, useState } from 'react';

interface Props {
  expiresAt: number;
  onExpire: () => void;
}

const Countdown: React.FC<Props> = ({ expiresAt, onExpire }) => {
  const [remaining, setRemaining] = useState(() => expiresAt - Date.now());

  useEffect(() => {
    // If we're already past expiresAt on mount (e.g. a session fetched just as
    // the timer ran out), fire the transition immediately instead of waiting
    // for the first 1s tick — the countdown should never sit silently on
    // "nothing rendered" while still technically ticking towards onExpire.
    const initial = expiresAt - Date.now();
    if (initial <= 0) {
      onExpire();
      return;
    }

    const id = setInterval(() => {
      const next = expiresAt - Date.now();
      setRemaining(next);
      if (next <= 0) {
        clearInterval(id);
        onExpire();
      }
    }, 1000);
    return () => clearInterval(id);
  }, [expiresAt, onExpire]);

  if (remaining <= 0) return null;

  const minutes = Math.floor(remaining / 60_000);
  const seconds = Math.floor((remaining % 60_000) / 1000);

  return (
    <p className="text-sm text-gray-500" data-testid="countdown">
      Товар зарезервовано ще на {minutes}:{String(seconds).padStart(2, '0')}
    </p>
  );
};

export default Countdown;
